import { render, staticRenderFns } from "./SearchItemsResult.vue?vue&type=template&id=05a1e8e6&"
import script from "./SearchItemsResult.vue?vue&type=script&lang=js&"
export * from "./SearchItemsResult.vue?vue&type=script&lang=js&"
import style0 from "./SearchItemsResult.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports